import { FC } from "react";
import { Link } from "react-router-dom";

import { Classes, SimpleFn } from "web/types/Common";

import classify from "web/classify";

import defaultClasses from "./navigationItem.scss";

interface ICheckoutNavigationItem {
  label: string | number;
  enabled: boolean;
  active: boolean;
  classes: Classes;
  onClick: SimpleFn;
  isThankYouPageHelper: boolean;
  link: string;
  stepKey?: number;
  showStepNumber?: boolean;
}

const CheckoutNavigationItem: FC<ICheckoutNavigationItem> = ({
  label,
  enabled,
  active,
  classes,
  onClick,
  isThankYouPageHelper,
  link,
  stepKey,
  showStepNumber = false,
}) => {
  const content =
    showStepNumber && stepKey != null ? (
      <>
        <span aria-hidden="true">{stepKey}</span>
        <span className="visually-hidden">{`${stepKey}, ${label}`}</span>
      </>
    ) : (
      label
    );

  if (enabled) {
    return (
      <>
        <span
          className={classes.connector}
          data-t1="navigation_list_item_connector"
          {...(showStepNumber ? { "aria-hidden": true as const } : null)}
        />
        <Link
          to={link}
          onClick={onClick}
          className={classes.link}
          data-t1="navigation_list_item_label"
        >
          {content}
        </Link>
      </>
    );
  }
  if (active) {
    return (
      <>
        {isThankYouPageHelper ? (
          <span
            className={classes.connector}
            data-t1="navigation_list_item_connector"
            {...(showStepNumber ? { "aria-hidden": true as const } : null)}
          />
        ) : null}
        <span data-t1="navigation_list_item_label" className={classes.active}>
          {content}
        </span>
      </>
    );
  }

  return (
    <span data-t1="navigation_list_item_label" className={classes.disabled}>
      {content}
    </span>
  );
};

export default classify<ICheckoutNavigationItem>(defaultClasses)(
  CheckoutNavigationItem
);
